(function () {
  if (window.__VitalisScienceReady) return;

  window.__VitalisScienceReady = true;

  function init() {
    var els = document.querySelectorAll('[data-vsci-reveal]');

    if (!els.length) return;

    var reduce =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var design =
      document.documentElement.classList.contains('shopify-design-mode') ||
      document.body.classList.contains('shopify-design-mode');

    /* =========================================
       REDUCED MOTION / SHOPIFY EDITOR
       ========================================= */
    if (
      reduce ||
      design ||
      !('IntersectionObserver' in window)
    ) {
      els.forEach(function (el) {
        el.classList.add('vsci-in');
      });

      return;
    }

    /* =========================================
       SCROLL REVEAL
       ========================================= */
    var io = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('vsci-in');

          obs.unobserve(entry.target);
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -7% 0px'
      }
    );

    els.forEach(function (el) {
      /*
       * Không observe lại element đã reveal.
       * Quan trọng khi Shopify Theme Editor reload section.
       */
      if (!el.classList.contains('vsci-in')) {
        io.observe(el);
      }
    });
  }

  /* =========================================
     INITIAL PAGE LOAD
     ========================================= */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );
  } else {
    init();
  }

  /* =========================================
     SHOPIFY THEME EDITOR
     Re-init khi section được add/reload
     ========================================= */
  document.addEventListener(
    'shopify:section:load',
    function () {
      requestAnimationFrame(init);
    }
  );
})();